// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui' // element-ui
import '~/css/index.css' // element-ui css样式
import '~/css/base.css' // 全局css
import '@/assets/css/base.css' // 全局css
import './permissions' // 全局路由钩子
import global from '@/untils/global' // 全局方法

import vueAplayer from 'vue-aplayer'
vueAplayer.disableVersionBadge = true
Vue.use(ElementUI)
Vue.use(global)
Vue.use(vueAplayer)

Vue.config.productionTip = false

const Base64 = require('js-base64').Base64
/* eslint-disable no-new */
new Vue({
  el: '#app',
  Base64,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js